import { OktaClientConfiguration } from './types-constants';
import memoize from 'fast-memoize';

export const isDefaultOktaClient = (
  oktaClientConfiguration: OktaClientConfiguration,
) => {
  return oktaClientConfiguration?.isDefault === true;
};

export const getDefaultOktaClientConfiguration = memoize(
  (oktaClientConfigurations: OktaClientConfiguration[]) => {
    return (oktaClientConfigurations || []).find((a) => !!a.isDefault);
  },
);

export const getNonDefaultOktaClientConfigurations = memoize(
  (oktaClientConfigurations: OktaClientConfiguration[]) => {
    return (oktaClientConfigurations || []).filter((a) => !a.isDefault);
  },
);
